"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("history");
var react_router_1 = require("react-router");
var init_1 = require("./init");
var history;
function ensureHistory() {
    history = react_router_1.useRouterHistory(history_1.createHistory)({
        basename: init_1.getUrlContext(),
    });
    return history;
}
function getHistory() {
    return history ? history : ensureHistory();
}
exports.default = getHistory;
//# sourceMappingURL=getHistory.js.map